import { render } from "./ElectionVoteSection.vue?vue&type=template&id=8ea9086a&scoped=true"
import script from "./ElectionVoteSection.vue?vue&type=script&lang=js"
export * from "./ElectionVoteSection.vue?vue&type=script&lang=js"

import "./ElectionVoteSection.vue?vue&type=style&index=0&id=8ea9086a&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea9086a"]])

export default __exports__